module.exports = __webpack_public_path__ + "static/media/VirtualPBX9.d75ea880.JPG";